import { render, staticRenderFns } from "./CollisionResolveDialog.vue?vue&type=template&id=a0d25866&scoped=true&"
import script from "./CollisionResolveDialog.vue?vue&type=script&lang=js&"
export * from "./CollisionResolveDialog.vue?vue&type=script&lang=js&"
import style0 from "./CollisionResolveDialog.vue?vue&type=style&index=0&id=a0d25866&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d25866",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/nextcloud/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0d25866')) {
      api.createRecord('a0d25866', component.options)
    } else {
      api.reload('a0d25866', component.options)
    }
    module.hot.accept("./CollisionResolveDialog.vue?vue&type=template&id=a0d25866&scoped=true&", function () {
      api.rerender('a0d25866', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "apps/text/src/components/CollisionResolveDialog.vue"
export default component.exports